<script type="text/javascript">
    
    import moment from "moment";
    import Chart from "chart.js";
    import { onDestroy, onMount } from "svelte";

    export let title = "Chart";
    export let days = 30;
    export let data = null;

    export let key = "Flag";        // refers to property name in <day data>
    export let subkey = "country";  // refers to property name in <day data>.<key>

    let chart = null;
    let canvas = null;


    onMount(() => {
       updateChart();
    })
    onDestroy(()=>{
		if (chart !== null) {
			chart.destroy();
			chart = null;
		}
    });
    $: {
        updateChart();
    }

    let updateChart = () => {
        // console.log("update chart", chart, canvas, data);
        if (chart === null && canvas !== null && data !== null) {
            
            let keyedData = {};
            data.sort((a, b) => {
                return moment(b.Date) - moment(a.Date);
            });
            // console.log("data", data);
            for(let i = 0; i < data.length && i < days; i++) 
            {
                let day = data[i].data;
                //let date_yyyymmdd = data[i].Date;
                // console.log("date_yyyymmdd", date_yyyymmdd);
                // let portName = data[i].port_name;
                for(let j = 0; j < day.Graph_type[key][subkey].length; j++) {
                    let keyName = day.Graph_type[key][subkey][j];
                    let count = day.Graph_type[key].count[j];
                    if (typeof keyedData[keyName] === "undefined") {
                        keyedData[keyName] = 0;
                    }
                    keyedData[keyName] += count; 
                }
            }

            const CHART_COLORS = {
                red: 'rgb(255, 99, 132)',
                orange: 'rgb(255, 159, 64)',
                yellow: 'rgb(255, 205, 86)',
                green: 'rgb(75, 192, 192)',
                blue: 'rgb(54, 162, 235)',
                purple: 'rgb(153, 102, 255)'
            };
            const chartData = {
                labels: Object.keys(keyedData), 
                datasets: [
                    {
                        label: title, //'Flag',
                        data: Object.values(keyedData), 
                        backgroundColor: Object.values(CHART_COLORS),
                    }
                ]
            };

            const config = {
                type: 'pie',
                data: chartData,
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: title //'Pie Chart'
                        }
                    }
                },
            };
            chart = new Chart(canvas.getContext("2d"), config);
        }
        if (chart !== null && canvas !== null) {
            chart.update();
        }
    };
    
</script>

<p><b>{title}</b></p>
<canvas bind:this={canvas}></canvas>    